import { TrainUsers } from "./trainusers.model";

export class Train {
  Id: number=0;
  PlantId: number=0;
  UserId: number=0;
  Permissions: number=0;
  Name: string="";
  RefPoint: number=0;
  Units: number=0;
  Notes: string="";
  Hybrid: number=0;
  Tcfa: number=0;
  CalcStage1Tcfa: number=0;
  CalcStage2Tcfa: number=0;
  CalcStage3Tcfa: number=0;
  CalcTfca: number=0;
  Tcfb: number=0;
  CalcStage1Tcfb: number=0;
  CalcStage2Tcfb: number=0;
  CalcStage3Tcfb: number=0;
  CalcTcfB: number=0;
  Stages: number=1;
  Stage1Vessels: number=0;
  Stage1ElementsVessel: number=0;
  Stage1Element1Model: number=0;
  Stage1Element1Qty: number=0;
  Stage1Element2Model: number=0;
  Stage1Element2Qty: number=0;
  Stage1Element3Model: number=0;
  Stage1Element3Qty: number=0;
  Stage2Vessels: number=0;
  Stage2ElementsVessel: number=0;
  Stage2ElementModel: number=0;
  Stage3Vessels: number=0;
  Stage3ElementsVessel: number=0;
  Stage3ElementModel: number=0;
  Ud1: string="";
  Ud2: string="";
  Ud3: string="";
  Ud4: string="";
  Ud5: string="";
  CreatedAt: Date;
  UpdatedAt: Date;
  Hybrid2: number=0;
  Stage2Element2Model: number=0;
  Stage2Element2Qty: number=0;
  Stage2Element3Model: number=0;
  Stage2Element3Qty: number=0;
  Stage2Element1Qty: number=0;
  Hybrid3: number=0;
  Stage3Element1Qty: number=0;
  Stage3Element2Model: number=0;
  Stage3Element2Qty: number=0;
  Stage3Element3Model: number=0;
  Stage3Element3Qty: number=0;
  Systemconfig: string="";
  AspNetUsersId: string="";
  NoUserSelected:boolean=false;
  AccessOption:number=1;

}
export class TrainViewmodel
{
  traindata:Train = new Train();
  trainuser:TrainUsers[]=[];
}


//Added below model for calender control

export class RefPointDateTime {
  RefPoint: number;
  DateTime: string;
}
 
 